module.exports = __webpack_public_path__ + "img/MeetingHub-NavLogo-Small.0a208ce1.png";